module.exports = {
	string2Object: function (s, a, b) {
		if (!a) {
			a = '=';
		};
		if (!b) {
			b = '&';
		}
		var ret = {};
		var strs = s.split(b);
		var tmp;
		var tmp_0;
		var tmp_1;
		for(var i = 0; i < strs.length; i ++) {
			tmp = strs[i].split(a);
			tmp_0 = tmp.shift();
			tmp_1 = tmp.join(a);
			if (tmp_0 && tmp_1) {
				ret[tmp_0] = decodeURI(tmp_1);
			}
		}
		return ret;
	},
	object2String: function (o, a, b) {
		if (!a) {
			a = '=';
		};
		if (!b) {
			b = '&';
		}
		var s = '';
		for (var i in o) {
			if (o[i] !== null && o[i] !== undefined) {
				s += i + a + o[i] + b;
			}
		}
		return s.slice(0, -1);
	}
}



//////////////////
// WEBPACK FOOTER
// ./~/@souche-f2e/chunyan-util/url_util/_key_value_util.js
// module id = 193
// module chunks = 1